import React from 'react';
import { FaCar, FaTools, FaShieldAlt } from 'react-icons/fa';

const highlights = [
  {
    icon: <FaCar />,
    title: "Vast and Diverse Fleet",
    description: "Explore our wide selection of vehicles, from luxury sedans to rugged SUVs, all meticulously maintained for your comfort and safety. We have the perfect car for every journey.",
  },
  {
    icon: <FaTools />,
    title: "Premium Maintenance",
    description: "Our cars are more than just vehicles; they are a promise of quality. Each one undergoes rigorous, regular maintenance to ensure peak performance and reliability on the road.",
  },
  {
    icon: <FaShieldAlt />,
    title: "Complete Transparency",
    description: "With Quick Wheels, what you see is what you get. We offer transparent pricing with no hidden fees, so you can book with confidence and peace of mind.",
  },
];

const HighlightsSection = () => {
  return (
    <section className="bg-slate-950 py-16 px-4 sm:px-6 lg:px-8">
      <div className="max-w-7xl mx-auto rounded-3xl bg-slate-900 p-8 md:p-16 grid grid-cols-1 lg:grid-cols-2 gap-12 items-center shadow-2xl transition-all duration-300 ease-in-out hover:shadow-[0_0_50px_10px_rgba(251,191,36,0.5)] hover:scale-[1.02]">
        {/* Left Side: Image */}
        <div className="rounded-lg overflow-hidden relative h-96">
          <img 
            src="assets/about-section.png" 
            alt="A car on a scenic road" 
            className="w-full h-full object-cover"
          />
        </div>
        
        {/* Right Side: Text and Highlights */}
        <div>
          <h2 className="text-4xl font-bold text-white leading-tight mb-6">
            Where every drive feels <span className="text-amber-400">extraordinary</span>
          </h2>
          <div className="space-y-8">
            {highlights.map((item, index) => (
              <div key={index} className="flex items-start space-x-6">
                <div className="flex-shrink-0 text-amber-400 text-3xl p-4 bg-slate-800 rounded-full">
                  {item.icon}
                </div>
                <div>
                  <h3 className="font-bold text-lg text-white">{item.title}</h3>
                  <p className="text-slate-400 text-sm mt-1">{item.description}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}

export default HighlightsSection;